var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-drop",class:{'setColor':_vm.activeColor},on:{"click":function($event){return _vm.handleClick()}}},[_c('div',{staticClass:"title-drop"},[_c('span',[_vm._t("label")],2),_c('i',{staticClass:"fa fa-chevron-down icon"})]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }